"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MessageListener_1 = __importDefault(require("../../Messages/MessageListener"));
var IFrameWidget_1 = __importDefault(require("../../Widgets/IFrameWidget"));
var ModalManager_1 = __importDefault(require("../modal/ModalManager"));
var RemoteVideoRequestHandler_1 = __importDefault(require("./RemoteVideoRequestHandler"));
var DataOverwriteRemoteVideoRequestHandler = /** @class */ (function (_super) {
    __extends(DataOverwriteRemoteVideoRequestHandler, _super);
    function DataOverwriteRemoteVideoRequestHandler(sessionManager) {
        return _super.call(this, sessionManager) || this;
    }
    /**
     * Maneja la peticion de tipo video
     * @param request
     */
    DataOverwriteRemoteVideoRequestHandler.prototype.handle = function (request) {
        this.request = request;
        //Limpiamos modal actual
        ModalManager_1.default.instance().clear();
        var config = this.createConfigForVideo();
        var iframe = this.iframeBuilder.build(config);
        var widget = new IFrameWidget_1.default(config, iframe);
        new MessageListener_1.default([widget]);
        ModalManager_1.default.instance().render();
    };
    /**
     * Inherits config from iframe but adds contentId from recivec video
     */
    DataOverwriteRemoteVideoRequestHandler.prototype.createConfigForVideo = function () {
        return this.overWriteData(_super.prototype.createConfigForVideo.call(this));
    };
    /**
     * Sobre escribe los datos del config elemento con el nodo overwrite del data de notificationEvent
     * @param arg0
     */
    DataOverwriteRemoteVideoRequestHandler.prototype.overWriteData = function (config) {
        var data = this.request.getNotificationEvent().data;
        if (data && data.video) {
            config.attributes.set("contentid", data.video._id);
        }
        //Si tenemos datos de overwrite
        if (data && data.overwrite) {
            if (data.overwrite.filter) {
                config.attributes.set("filter", data.overwrite.filter);
            }
            if (data.overwrite.type) {
                config.type = data.overwrite.type;
            }
            if (data.overwrite.filterType) {
                config.attributes.set("filter-type", data.overwrite.filterType);
            }
        }
        return config;
    };
    /**
     * Añade el iframe generado al body de la página
     * @param iframe
     */
    DataOverwriteRemoteVideoRequestHandler.prototype.addIframeToWindow = function (iframe) {
        window.parent.document.body.append(iframe);
    };
    return DataOverwriteRemoteVideoRequestHandler;
}(RemoteVideoRequestHandler_1.default));
exports.default = DataOverwriteRemoteVideoRequestHandler;
